/**
 * Копирование значения в буффер обмена
 * @param value - строка для копирования
 */
export const copyToClipboard = (value: string) => {
  const textArea = document.createElement('textarea')

  textArea.value = value
  document.body.appendChild(textArea)

  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    textArea.readOnly = true

    // create a selectable range
    const range = document.createRange()
    range.selectNodeContents(textArea)

    // Получаем диапозон выделенной строки
    const selection = window.getSelection()

    if (selection === null) return

    selection.removeAllRanges()
    selection.addRange(range)
    textArea.setSelectionRange(0, 999999)
  } else textArea.select()

  const successful = document.execCommand('copy')

  textArea.remove()

  if (!successful) {
    throw new Error('Копирование в буфер обмена недоступно в этом браузере')
  } else return successful
}

export const copyToClipboardNew = async (text: string) => {
  try {
    // Проверяем, поддерживается ли API
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text)
      return true
    } else {
      // Для старых браузеров
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      return true
    }
  } catch {
    return false
  }
}
